import React from "react";
import { MessageList, MessageInput } from "../../components";
import { useChat } from "../../hooks/useChat";

const HomePage: React.FC = () => {
  const { messages, inputMessage, isLoading, setInputMessage, handleSend } =
    useChat();

  return (
    <div className="h-full flex flex-col bg-gray-50">
      {/* Chat Container */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <div className="flex-1 overflow-y-auto p-4">
          <MessageList messages={messages} isLoading={isLoading} />
        </div>

        {/* Input Area */}
        <div className="border-t bg-white p-4 shadow-sm">
          <MessageInput
            value={inputMessage}
            onChange={setInputMessage}
            onSend={handleSend}
            disabled={isLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default HomePage;
